import api from '@/api/notification';

let requestIntervalId = null;
const REQUEST_TIMEOUT = 10000;

export default {
  namespaced: true,
  state: () => ({
    items: [],
  }),
  getters: {},
  mutations: {
    setItems(state, payload) { state.items = payload; },
    hideItem(state, item) {
      const itemOfList = state.items.find((i) => i.id === item.id);
      itemOfList.isHidden = true;
    },
    viewItem(state, item) {
      const itemOfList = state.items.find((i) => i.id === item.id);
      itemOfList.isViewed = true;
    },
    removeItem(state, item) {
      state.items = state.items.filter((i) => i.id !== item.id);
    },
  },
  actions: {
    view({ commit }, item) {
      commit('viewItem', item);
      api.update(item.id, { isViewed: true });
    },
    hide({ commit }, item) {
      commit('viewItem', item);
      commit('hideItem', item);
      api.update(item.id, { isViewed: true, isHidden: true });
    },
    delete({ commit }, item) {
      commit('removeItem', item);
      api.delete(item.id);
    },
    fetch({ state, commit, rootState }) {
      if (requestIntervalId) return;

      const fetchList = (isInitialRequest) => {
        api.fetchList().then((r) => {
          const unreadItemsCountBecame = r.items.filter(n => !n.isViewed).length;
          const unreadItemsCountWas = state.items.filter(n => !n.isViewed).length;

          const soundDisabled = rootState.auth.user?.customSettings?.notifications?.soundDisabled;
          if (!isInitialRequest && soundDisabled !== true) {
            if (unreadItemsCountBecame > unreadItemsCountWas) {
              (new Audio('/notification.mp3')).play();
            }
          }

          const favicon = document.getElementById('favicon');
          favicon.href = unreadItemsCountBecame ? '/favicon_active.svg' : '/favicon.svg';

          commit('setItems', r.items);
        });
      };

      fetchList(true);

      requestIntervalId = setInterval(() => {
        if (document.hidden) return;
        fetchList(false);
      }, REQUEST_TIMEOUT);
    },
  },
};
